import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Facility {
  constructor (params = {}) {
    const {
      id,
      sequence,
      name,
      timezone,
      baseCurrency,
      baseCurrencyId,
      externalIds,
      defaultLanguageCode,
      allowedLanguageCodes
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.name = name || null
    this.timezone = timezone || null
    this.baseCurrencyId = baseCurrencyId || null
    this.baseCurrency = baseCurrency || this.baseCurrencyId
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.defaultLanguageCode = defaultLanguageCode || null
    this.allowedLanguageCodes = allowedLanguageCodes || []
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      name: item.name,
      timezone: item.timezone,
      baseCurrencyId: item.baseCurrencyId,
      defaultLanguageCode: item.defaultLanguageCode,
      allowedLanguageCodes: item.allowedLanguageCodes
    }
  }
}
